// URL d'annonce -> comercializadora. Une entrée = une page marque servie à cette URL exacte
// (comparaison insensible à la casse). Pas de logo de marque : seulement le nom, en texte.
// primary = couleur des boutons d'appel (tableau « Couleur Primaire (CTA) »), secondary = couleur d'accent.
// site = site officiel de la marque, cité dans l'encadré « Mis Gestiones Luz no es [marca] ».
//        Laisser vide si l'adresse n'est pas vérifiée : l'encadré renvoie alors vers la facture.
// phone = numéro propre à la page (clé de PHONE_CONFIG.ES.energia), sinon numéros LP / SB par défaut.
// Les URL partagées avec « Master Campaign MC - OSB » affichent la marque de la campagne marque.

export const PROVIDERS = {
  "/comparador-luz": { name: "Naturgy", site: "naturgy.es", primary: "#005795", secondary: "#ED7004" },
  "/comparador/luz": { name: "Baser", site: "", primary: "#000000" },
  "/comparamos-tarifas": { name: "Plenitude", site: "eniplenitude.es", primary: "#3DA956" },
  "/comparamos/luz": { name: "TotalEnergies", site: "totalenergies.es", primary: "#FE0201", secondary: "#0D7AF7" },
  "/comparar-ofertas-luz": { name: "Energía XXI", site: "energiaxxi.com", primary: "#FF0164", secondary: "#1E1F1C" },
  "/comparar/luz": { name: "Energía XXI", site: "energiaxxi.com", primary: "#FF0164", secondary: "#1E1F1C" },
  "/comparar-tarifas-luz": { name: "Iberdrola", site: "iberdrola.es", primary: "#02A444", secondary: "#FF9C1A" },
  "/ofertas-luz": { name: "Endesa", site: "endesa.com", primary: "#008ACE", phone: "ENDESA" },
  "/ofertas-luz-comparador": { name: "Repsol", site: "repsol.es", primary: "#041E42", secondary: "#F39D09" },
  "/ofertas-luz-comprador": { name: "Curenergía", site: "", primary: "#2D5B45" },
  "/telefono-luz": { name: "Factor Energía", site: "factorenergia.com", primary: "#0951A5" },
  "/telefono-luz-verde": { name: "Octopus Energy", site: "octopusenergy.es", primary: "#140432", secondary: "#FF48D8" },
};

// Anciennes URL d'annonces qui affichent la page d'accueil (même contenu, canonical vers /, pas de redirection).
// /telefono/luz : campagne « E Distribucion » (distributeur d'électricité, comme Enedis en France) :
// pas de page marque pour un gestionnaire de réseau. Campagne à supprimer après réactivation du compte.
export const HOME_ALIASES = ["/telefono/luz"];
